import { take } from 'rxjs';

import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { BaseLeadRequestDetailComponent } from '@leads/client-facing/classes/base-lead-request-detail.component';
import { AlertComponent } from '@shared/components/alerts/alert/alert.component';
import { LinkEmailComponent } from '@shared/components/buttons/link-email/link-email.component';
import { LinkLocationComponent } from '@shared/components/buttons/link-location/link-location.component';
import { LinkPhoneNumberComponent } from '@shared/components/buttons/link-phone-number/link-phone-number.component';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';
import { IStepNavigation, IStepNavigatorConfig, NavButtonStyle, StepDisplay, StepModes, StepUI } from '@shared/models/step-navigator';
import { NgbDateToDatePipe } from '@shared/pipes/ngb-date-to-date.pipe';
import { NullDefaultPipe } from '@shared/pipes/null-default.pipe';

import { MobileScheduledItemsListOffcanvasComponent } from '../mobile-scheduled-items-list-offcanvas/mobile-scheduled-items-list-offcanvas.component';

enum LeadRequestViewOptions {
	CONTACT_DETAILS = 'CONTACT_DETAILS',
	CLIENT_REQUIREMENTS = 'CLIENT_REQUIREMENTS',
	INTERNAL_NOTES = 'INTERNAL_NOTES',
}

@Component({
	selector: 'app-mobile-lead-request-detail',
	imports: [
		CommonModule,
		NgbDateToDatePipe,
		TextareaControlComponent,
		AlertComponent,
		LinkLocationComponent,
		NullDefaultPipe,
		StepNavigatorComponent,
		LinkEmailComponent,
		LinkPhoneNumberComponent,
	],
	templateUrl: './mobile-lead-request-detail.component.html',
	styleUrl: './mobile-lead-request-detail.component.scss',
})
export class MobileLeadRequestDetailComponent extends BaseLeadRequestDetailComponent {
	openScheduleItemsListOffcanvas() {
		const ref = this.offcanvasService.open(MobileScheduledItemsListOffcanvasComponent, 'end', true, 'oc-lg');
		const componentInstance = ref.componentInstance as MobileScheduledItemsListOffcanvasComponent;
		componentInstance.leadRequest = this.leadRequest;
		componentInstance.isSavingNotes = this.isSavingNotes;
		componentInstance.isSavingJobDescription = this.isSavingJobDescription;
		componentInstance.client = this.client;
		componentInstance.scheduledItems = this.scheduledItems;
		componentInstance.internalNotesForm = this.internalNotesForm;
		componentInstance.readonlyView = this.readonlyView;
		componentInstance.newScheduledItemCreated.pipe(take(1)).subscribe(() => {
			this.newScheduledItemCreated.emit();
		});
	}

	LeadRequestViewOptions = LeadRequestViewOptions;

	navigationConfig: IStepNavigatorConfig = {
		ui: StepUI.WIZARD,
		mode: StepModes.NG_SWITCH,
		displayType: StepDisplay.TABS,
		navButtonStyle: NavButtonStyle.CHEVRON,
		showStepChevrons: false,
		showStepNumbers: false,
		showNavButtons: true,
		steps: [
			{
				title: {
					full: 'Contact Details',
					tabs: 'Contact Details',
				},
				icon: '',
				switchCase: LeadRequestViewOptions.CONTACT_DETAILS,
			},
			{
				title: {
					full: 'Client Requirements',
					tabs: 'Client Requirements',
				},
				icon: '',
				switchCase: LeadRequestViewOptions.CLIENT_REQUIREMENTS,
			},
			{
				title: {
					full: 'Internal Notes',
					tabs: 'Internal Notes',
				},
				icon: '',
				switchCase: LeadRequestViewOptions.INTERNAL_NOTES,
			},
		],
	};

	selectedStep: IStepNavigation = this.navigationConfig.steps[1];
}
